import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ListService } from '../services';
import { BaseComponent } from '../shared';
import { FiltersComponent } from './filters';
import { ListTemplateComponent } from './list-template';


/**
* Patient and plan list page component.
*/
@Component({
	selector: 'app-list',
	templateUrl: './list.component.html',
	imports: [
		RouterOutlet,
		FiltersComponent,
		NgbCollapseModule,
		ListTemplateComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ListComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly listSrv = inject(ListService);

	isFiltersCollapsed = false;

	private _collapsedSub?: Subscription;


	ngOnInit(): void {
		this._collapsedSub = this.listSrv.isCollapsed.subscribe(val => this.isFiltersCollapsed = val);
	}

	/**
	 * Update filter collapsed status.
	 */
	updateCollapsed(val: boolean): void {
		this.listSrv.collapse(val);
	}

	ngOnDestroy(): void {
		this._collapsedSub?.unsubscribe();
	}

}
